import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isErrorResponse, safelyParseJson } from '@utils/utils';
import { useCloneTransitEntities } from '@hooks/transitlLines/useCloneTransitEntities';
import { useToastContext } from '@context/toastContext';
import Button from '@components/buttons/Button';
import { LoadingBackdrop } from '@components/LoadingBackdrop/LoadingBackdrop';
import { ActionDialogProps, ActionMenuProps } from '@components/ActionMenu/ActionMenu';

const InvertRouteActionFabric = ({ id, loadEntitiesFn }: ActionMenuProps) => {
    const InvertRouteAction: React.FC<ActionDialogProps> = ({
        handleCloseDialog,
    }: ActionDialogProps) => {
        const { loading, invertRoute } = useCloneTransitEntities();
        const { addToast } = useToastContext();
        const { t } = useTranslation();

        const cancelHandler = useCallback(
            event => {
                handleCloseDialog(event);
            },
            [handleCloseDialog]
        );

        const invertRouteHandler = useCallback(
            async event => {
                const resp = await invertRoute({ routeId: id });
                if (isErrorResponse(resp)) {
                    const error =
                        typeof resp.error === 'string' ? safelyParseJson(resp.error) : resp.error;
                    addToast(`${error?.['details'] ?? t('common.save-error')}`, 'error');
                } else {
                    await loadEntitiesFn();
                    addToast(`${t('common.save-successful')}`, 'success');
                }

                handleCloseDialog(event);
            },
            [id, addToast]
        );

        return (
            <LoadingBackdrop isVisible={loading} transparent>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button
                        type="submit"
                        onClick={invertRouteHandler}
                        text={t('transit-lines.invert-route')}
                        colorType="dark"
                        testId="deleteConfirmationModalDeleteBtn"
                    />
                    <Button
                        onClick={cancelHandler}
                        text={t('common.cancel')}
                        colorType="transparent"
                    />
                </div>
            </LoadingBackdrop>
        );
    };

    return InvertRouteAction;
};

export default InvertRouteActionFabric;
